import React from 'react';

import { OpenConvalidaResponse, Group } from 'models/response';

import Hierarchy from 'components/Hierarchy';

interface Props {
  title: string;
  response: OpenConvalidaResponse;
  setSelectedGroups: (groups: Group[]) => void;
}

const columns = [
  { accessor: 'username', Header: 'User' },
  { accessor: 'name', Header: 'Name' },
];

const searchTypeValues: { value: string; label: string; parent: 'one' | 'two' | 'three' | 'table' }[] = [
  { value: 'group', label: 'Group', parent: 'two' },
  { value: 'user', label: 'User', parent: 'table' },
];

const Groups = (props: Props) => {
  const { title, response, setSelectedGroups } = props;

  const groups = response.escalationGroups?.groups;

  return (
    <Hierarchy
      title={title}
      hasSearch
      searchTypeValues={searchTypeValues}
      parentsTwo={groups}
      parentTwoName="groupName"
      parentTwoId="idGroup"
      parentTwoSelection={(isActive?: boolean, value?: any) => {
        setSelectedGroups && setSelectedGroups(value);
      }}
      parentTwoChild="users"
      parentTwoHasTable={true}
      idRowTable="idUser"
      columns={columns}
      tableValueName="username"
      tableValueNameTwo="name"
    />
  );
};

export default Groups;
